import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    display: "flex",
    alignItems: "center",
    gap: ({ spacing }) => spacing(1),
  },

  user: {
    fontSize: "12px",
  },
};
